export default __webpack_public_path__ + "static/fieqNnMW-422df1cefcac3d25e036fef89cb10faf.svg";